var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MeestReturnsListUser',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams},on:{"createConsolidationMeest":_vm.createConsolidationMeest,"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"changeFilter":_vm.changeFilter,"reload":_vm.reload,"massThermalPrint":_vm.massThermalPrint}})
}
var staticRenderFns = []

export { render, staticRenderFns }